/** IDs canônicos de db_dfe.modelo_documento expostos pelos contratos públicos. */
export enum ModeloDocumentoEnum {
  NFe = 1,
  NFCe = 2,
  CTe = 3,
  MDFe = 4,
  NFCom = 5,
  BPe = 6,
  GTVe = 7,
  NF3e = 8,
  CTeOS = 9,
  NFAg = 10,
  NFGas = 11,
  NFeABI = 12,
  DCe = 13,
  NFSe = 14
}
